import { useUpdateManagementKeyStatus } from '@api/managementKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import { AccessKeyStatusDialog } from '../../AccessKeys/index';

const StatusDialog: React.FC<IRowActionDialogProps> = (props) => {
	const mutation = useUpdateManagementKeyStatus();
	return (
		<AccessKeyStatusDialog
			{...props}
			mutation={mutation}
			accessKeyType={AccessKeyType.management}
		/>
	);
};

export default StatusDialog;
